<template>
  <nav class="bg-woo shadow" id="app">
    <div class="container px-6 py-2 mx-auto">
      <div class="md:flex justify-between items-center">
        <!-- left section -->
        <div class="flex justify-between items-center">
          <a
            href="/main-page"
            class="text-gray-800 italic text-xl font-bold hover:text-gray-700 md:text-5xl"
          >
            Whizz
          </a>
          <div class="md:hidden">
            <button type="button" class="text-white" @click="isOpen = !isOpen">
              <MenuIcon v-if="!isOpen" />
              <XIcon v-else />
            </button>
          </div>
        </div>
        <!-- right section -->
        <div
          class="flex-col mt-3 md:flex-row md:mt-0 md:flex"
          :class="isOpen ? 'flex' : 'hidden'"
          @click="isOpen = !isOpen"
        >
          <router-link v-if="this.$store.state.permissions.projectsPage"
            to="/projects"
            class="flex items-center p-2 text- font-normal text-gray-900 rounded-lg hover:text-white"
          >
            <FolderIcon />
            <span class="ml-3">Projects</span>
          </router-link>

          <router-link v-if="this.$store.state.permissions.batchesPage"
            to="/batches"
            class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:text-white"
          >
            <CollectionIcon />
            <span class="ml-3">Batches</span>
          </router-link>

          <router-link
            v-if="this.$store.state.permissions.usersPage"
            to="/Users"
            class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg hover:text-white"
          >
            <UsersIcon />
            <span class="ml-3">Users</span>
          </router-link>

           <router-link
            v-if="this.$store.state.permissions.showWhizz"
            to="/SearchName"
            class="flex items-center p-2 text- font-normal text-gray-900 rounded-lg hover:text-white"
          >
            <SearchIcon />
            <span class="ml-3">SearchName</span>
          </router-link>

           <router-link
            v-if="this.$store.state.permissions.showWhizz"
            to="/OCR"
            class="flex items-center p-2 text- font-normal text-gray-900 rounded-lg hover:text-white"
          >
            <CameraIcon />
            <span class="ml-3">OCR</span>
          </router-link>

          <t-dropdown>
            <div
              slot="trigger"
              slot-scope="{
                mousedownHandler,
                focusHandler,
                blurHandler,
                keydownHandler,
                isShown,
              }"
            >
              <button
                id="user-menu"
                class="ml-3 py-2 flex items-center text-base font-bold text-gray-200 transition duration-150 ease-in-out bg-woo rounded-full"
                :class="{ 'bg-gray-300 outline-0 text-white ': isShown }"
                aria-label="User menu"
                aria-haspopup="true"
                @mousedown="mousedownHandler"
                @focus="focusHandler"
                @blur="blurHandler"
                @keydown="keydownHandler"
                style="background-color:transparent !important"
              >
                <img
                  class="w-8 h-8 mr-2 rounded-full"
                  src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png"
                  alt=""
                />

                Hi, {{ userName }}!
              </button>
            </div>

            <div slot-scope="{ hide, blurHandler }">
              <button
                class="w-full px-4 py-2 flex items-center p-2 text-base font-normal text-black rounded-lg cursor-pointer hover:text-white leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem"
                @blur="blurHandler"
                @click="logout()"
              >
                <LogoutIcon />
                <span class="ml-3">Logout</span>
              </button>

              <button
                class="block w-full px-4 py-2 text-sm leading-5 text-red-500 transition duration-150 ease-in-out border-t hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                @click="hide"
              >
                Close
              </button>
            </div>
          </t-dropdown>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import Vue from "vue";
import VueTailwind from "vue-tailwind";
import { TDropdown } from "vue-tailwind/dist/components";
import router from "../router/index";
Vue.use(VueTailwind);
import {
  LogoutIcon,
  HomeIcon,
  UsersIcon,
  FolderIcon,
  CollectionIcon,
  MenuIcon,
  XIcon,
  SearchIcon,
  CameraIcon
} from "@vue-hero-icons/outline";

export default {
  components: {
    TDropdown,
    LogoutIcon,
    UsersIcon,
    FolderIcon,
    CollectionIcon,
    MenuIcon,
    XIcon,
    SearchIcon,
    CameraIcon
  },

  methods: {
    logout() {
      this.$store.commit("logout");
      router.replace({ path: "/login" });
    },
  },
  created() {
  },

  data() {
    return {
      userName: this.$store.state.username,
      isOpen: false,
    };
  },
};
</script>
<style>
button:focus {
  outline: none !important;
}
.router-link-active {
  color: black !important;
}
a {
  color: white !important;
}

a:hover {
  color: black  !important;
  text-decoration: none !important;
}
button:hover {
  color: white;
  background-color: #dadada !important;
}
</style>
